export function initSwitchableItems(itemsWrapClass, itemClass) {
    if (itemsWrapClass && itemClass) {
        const itemsWrap = document.querySelectorAll(itemsWrapClass);
        itemsWrap.forEach((wrap) => {
            const items = wrap.querySelectorAll(itemClass);
            for (let i = 0; i < items.length; i++) {
                items[i].addEventListener("click", (e) => {
                    e.preventDefault();
                    
                    items.forEach((item) => {
                        if (item.classList.contains("active")) {
                            item.classList.remove("active");
                        }
                    });
                    items[i].classList.add("active");
                });
            }
        });
    }
}